import React, {
  Dispatch,
  FC,
  useContext,
  useEffect,
} from 'react';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';
import { GiHamburgerMenu } from 'react-icons/gi';
import { Link, useLocation } from 'react-router-dom';
import Categories from '../Categories/Categories';
import styles from './HamburgerMenu.module.scss';
import { Context } from '../../Context/Context';
import { types } from '../../Context/Reducers/Reducer';

import { auth } from '../../Services/firebase';

interface Props {
  isOpen: boolean,
  setIsOpen: Dispatch<React.SetStateAction<boolean>>,
}

const HamburgerMenu: FC<Props> = ({
  isOpen, setIsOpen,
}) => {
  const location = useLocation();
  const onHandleMenu = () => setIsOpen((prevState) => !prevState);
  const { user, dispatch } = useContext(Context);

  const toggleModal = () => {
    dispatch({
      type: types.SHOW_MODAL,
    });
  };

  const handleAuth = () => {
    if (user) {
      const result = window.confirm('Are you sure you want to LogOut?');
      if (result) {
        auth.signOut();
      }
    } else {
      toggleModal();
    }
  };

  useEffect(() => () => setIsOpen(false), [location]);

  return (
    <IconContext.Provider value={{
      style: { verticalAlign: 'middle', fontSize: '2rem' },
    }}
    >
      <div className={styles.drawer}>
        <div className={styles.hamburgerMenu} onClick={onHandleMenu} aria-hidden="true">
          <GiHamburgerMenu />
        </div>

        <nav className={`${styles.drawerLeft} ${isOpen && styles.open}`}>
          <div className={styles.drawerHeader}>
            <GrClose size="1.5rem" onClick={() => setIsOpen(!isOpen)} style={{ cursor: 'pointer' }} />
            <Link to="/" className={styles.linkStyle}>
              <h3>Little Tags</h3>
            </Link>
          </div>
          {
            !!user
            && (
              <div className={styles.contactDetails}>
                <img className={styles.profilePic} src={user.photoURL} alt="Profile Pic" />
                <div className={styles.userName}>{user && `Hey, ${user.displayName.split(' ')[0]}`}</div>
              </div>
            )
          }
          <ul className={styles.category}>
            <h3>Categories</h3>
            <Categories />
            <div className={styles.divider} />
          </ul>
          {
            !!user
            && (
              <ul className={styles.order}>
                <Link to="/orders" className={styles.linkStyle}>
                  <li>Past Orders</li>
                </Link>
                <Link to="/add-address" className={styles.linkStyle}>
                  <li>Add Address</li>
                </Link>
              </ul>
            )
          }
          <div
            className={styles.logout}
            onClick={handleAuth}
            onKeyDown={handleAuth}
            role="button"
            tabIndex={0}
          >
            {
              user ? 'LogOut' : 'LogIn'
            }
          </div>
        </nav>
      </div>
    </IconContext.Provider>
  );
};
export default HamburgerMenu;
